const playlistCollection = {
	image: "https://i.scdn.co/image/ab67706c0000da8481b3e56a7977ac731b8c0697",
	type: "Playlist",
	name: "BLACKPINK Complete Collection",
	owner: "BLACKPINK",
	likes: "891,218 likes",
	totalTime: "about 2 hr",
	songs: [
		{
			name: "You & Me",
			img: "https://i.scdn.co/image/ab67616d000048518cd1023ed6ec97598937d55c",
			owner: "JENNIE",
			album: "JENNIE Special Single [You & Me]",
			date: "6 Oct 2023",
			duration: "2:59",
			src:"/assets/spotify/You & Me.mp3"
		},
		{
			name: "THE GIRLS - BLACKPINK THE GAME OST",
			img: "https://i.scdn.co/image/ab67616d0000485181b059b0093259b70170b64b",
			owner: "BLACKPINK",
			album: "THE GIRLS (BLACKPINK THE GAME OST)",
			date: "25 Aug 2023",
			duration: "2:42",
		},
		{
			name: "FLOWER",
			img: "https://i.scdn.co/image/ab67616d00004851f35b8a6c03cc633f734bd8ac",
			owner: "JISOO",
			album: "ME",
			date: "31 Mar 2023",
			duration: "2:53",
		},
		{
			name: "All Eyes On Me",
			img: "https://i.scdn.co/image/ab67616d00004851f35b8a6c03cc633f734bd8ac",
			owner: "JISOO",
			album: "ME",
			date: "31 Mar 2023",
			duration: "2:43",
		},
		{
			name: "Shut Down",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "The Happiest Girl",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "Pink Venom",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "Typa Girl",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "Yeah Yeah Yeah",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "Hard to Love",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "Tally",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "Ready For Love",
			img: "https://i.scdn.co/image/ab67616d000048514aeaaeeb0755f1d8a8b51738",
			owner: "BLACKPINK",
			album: "BORN PINK",
			date: "16 Sept 2022",
			duration: "2:55",
		},
		{
			name: "How You Like That",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "BLACKPINK",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "Ice Cream (with Selena Gomez)",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "BLACKPINK, Selena Gomez",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "Pretty Savage",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "BLACKPINK",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "Lovesick Girls",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "BLACKPINK",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "Bet You Wanna (feat. Cardi B)",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "BLACKPINK",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "Crazy Over You",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "BLACKPINK",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "Love To Hate Me",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "BLACKPINK",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "You Never Know",
			img: "https://i.scdn.co/image/ab67616d00004851330f11fb125bb80b760f9e19",
			owner: "BLACKPINK",
			album: "THE ALBUM",
			date: "2 Oct 2020",
			duration: "2:55",
		},
		{
			name: "LALISA",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "LISA",
			album: "LALISA",
			date: "10 Sept 2021",
			duration: "3:20",
		},
		{
			name: "MONEY",
			img: "https://i.scdn.co/image/ab67616d000048517dd8f95320e8ef08aa121dfe",
			owner: "LISA",
			album: "LALISA",
			date: "10 Sept 2021",
			duration: "2:48",
		},
		{
			name: "On The Ground",
			img: "https://i.scdn.co/image/ab67616d00004851fdec91537c467efa0cd75e2f",
			owner: "ROSÉ",
			album: "R",
			date: "18 Feb 2022",
			duration: "2:48",
		},
		{
			name: "Gone",
			img: "https://i.scdn.co/image/ab67616d00004851fdec91537c467efa0cd75e2f",
			owner: "ROSÉ",
			album: "R",
			date: "18 Feb 2022",
			duration: "2:48",
		},
		{
			name: "Sour Candy (with BLACKPINK)",
			img: "https://i.scdn.co/image/ab67616d00004851348a8b432f3e8e02f342056e",
			owner: "Lady Gaga, BLACKPINK",
			album: "R",
			date: "18 Feb 2022",
			duration: "2:48",
		},
		{
			name: "Kick It",
			img: "https://i.scdn.co/image/ab67616d000048515dcded478bd1a908dbabf05e",
			owner: "BLACKPINK",
			album: "Kill This Love",
			date: "9 Dec 2019",
			duration: "2:48",
		},
		{
			name: "Hope Not",
			img: "https://i.scdn.co/image/ab67616d000048515dcded478bd1a908dbabf05e",
			owner: "BLACKPINK",
			album: "Kill This Love",
			date: "9 Dec 2019",
			duration: "2:48",
		},
		{
			name: "DDU-DU DDU-DU - Remix",
			img: "https://i.scdn.co/image/ab67616d000048515dcded478bd1a908dbabf05e",
			owner: "BLACKPINK",
			album: "Kill This Love",
			date: "9 Dec 2019",
			duration: "2:48",
		},
		{
			name: "SOLO",
			img: "https://i.scdn.co/image/ab67616d0000485162e6288a5887b95176cca29e",
			owner: "JENNIE",
			album: "SOLO",
			date: "9 Dec 2019",
			duration: "2:48",
		},
		{
			name: "Kiss and Make Up",
			img: "https://i.scdn.co/image/ab67616d00004851ae395b47b186c2bc8c458e0f",
			owner: "Dua Lipa, BLACKPINK",
			album: "Kill This Love",
			date: "9 Dec 2019",
			duration: "2:48",
		},
		{
			name: "As If It's Your Last",
			img: "https://i.scdn.co/image/ab67616d00004851d9ac4a9970da8f98ce2e2b35",
			owner: "BLACKPINK",
			album: "Kill This Love",
			date: "9 Dec 2019",
			duration: "2:48",
		},
	],
};

export default playlistCollection;
